<template>
  <button
    class="ai-skill-toggle"
    type="button"
    title="Codelos AI öffnen"
    @click="$emit('toggle')"
  >
    <img src="@/assets/newLogo.svg" alt="Codelos AI" />
  </button>
</template>

<script>
export default {
  name: 'AISkillToggle',
  emits: ['toggle'],
};
</script>

<style scoped>
.ai-skill-toggle {
  position: fixed;
  right: 20px;
  bottom: 20px;
  width: 55px;
  height: 55px;
  border: none;
  border-radius: 50%;
  background: #111;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 12010;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.ai-skill-toggle img {
  width: 40px;
}

.ai-skill-toggle:hover {
  transform: scale(1.08);
  background: #222;
}

@media (max-width: 768px) {
  .ai-skill-toggle {
    right: 16px;
    bottom: 16px;
  }
}
</style>
